/** @module BarChartComponent */
import AxisHelper from '../chart_helpers/AxisHelper'
import BarChartViz from '../vizs/BarChartViz'
import BaseComponent from './BaseComponent'

/**
 * # {componentLabel} (`class {componentClassName}`)
 * A bar chart is used to display values of a single variable represented by the height or length of lines or rectangles of equal width.
 *
 * ### Example Usage
 * ```javascript
 *   import {BarChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new BarChart($el, data, config);
 *
 * ```
 *
 * This chart is only intended to draw simple bar charts (vertical or horizontal) for stacked or grouped bar charts see [StackedBarChart](#/developer/StackedBarsComponent) and [GroupedBarChart](#/developer/GroupedBarsComponent)
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 columns. Each row represents a bar, and the first column should be the id/label of the bar, and the second column its value.
 *
 * | category | value  |
 * | -------- | ------ |
 * |   a      |    22.4|
 * |   b      |    52.3|
 * |   c      |    12.8|
 * |   d      |    26.0|
 *
 * {.data-table}
 *
 */
export default class BarChartComponent extends BaseComponent {
  static componentLabel = 'Bar chart'
  static vizClass = BarChartViz
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: 'y0', types: [Number], role: 'value', roleLabel: 'Value' },
  ]
  constructor($root, config, data) {
    super($root, config, data)
  }
  static defaultConfig = {
    title: this.componentLabel,
    AxisHelper: {
      x: {
        /**
         * Show/hide labels for each bar on the X axis.
         */
        showTickValues: true,
      },
    },
  }
}
